(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('before-after-slider')) return;
    customElements.define('before-after-slider', class extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.ba__frame');
        this.range = this.querySelector('.ba__range');
        if (!this.frame || !this.range) return;
        this.set(this.range.value);
        this.range.addEventListener('input', () => this.set(this.range.value));
        this.frame.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.dragging = true;
          this.classList.add('is-dragging');
          if (this.frame.setPointerCapture) {
            try { this.frame.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
          }
          this.fromEvent(e);
        });
        this.frame.addEventListener('pointermove', (e) => { if (this.dragging) this.fromEvent(e); });
        const stop = () => { this.dragging = false; this.classList.remove('is-dragging'); };
        this.frame.addEventListener('pointerup', stop);
        this.frame.addEventListener('pointercancel', stop);
        this.frame.addEventListener('lostpointercapture', stop);
      }
      fromEvent(e) {
        const rect = this.frame.getBoundingClientRect();
        if (!rect.width) return;
        const pct = Math.min(100, Math.max(0, ((e.clientX - rect.left) / rect.width) * 100));
        this.range.value = Math.round(pct);
        this.set(pct);
      }
      set(value) {
        this.style.setProperty('--pos', `${Number(value)}%`);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    if (customElements.get('address-form')) return;
    customElements.define('address-form', class extends HTMLElement {
      connectedCallback() {
        this.country = this.querySelector('[data-country-select]');
        this.province = this.querySelector('[data-province-select]');
        this.provinceWrap = this.querySelector('[data-province-wrap]');
        if (this.country && this.province) {
          const wanted = this.country.dataset.default;
          if (wanted && Array.from(this.country.options).some((o) => o.value === wanted)) this.country.value = wanted;
          this.country.addEventListener('change', () => this.fillProvinces());
          this.fillProvinces(this.province.dataset.default);
        }
        const details = this.closest('details');
        if (details && this.querySelector('[data-form-errors]')) {
          details.open = true;
          details.scrollIntoView({ block: 'start' });
        }
        this.querySelectorAll('[data-address-cancel]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            if (!details) return;
            details.open = false;
            const summary = details.querySelector('summary');
            if (summary) summary.focus();
          });
        });
      }
      fillProvinces(selected) {
        const option = this.country.options[this.country.selectedIndex];
        let provinces = [];
        try { provinces = JSON.parse((option && option.dataset.provinces) || '[]'); } catch (e) { provinces = []; }
        this.province.innerHTML = '';
        provinces.forEach((entry) => {
          const value = Array.isArray(entry) ? entry[0] : entry;
          const label = Array.isArray(entry) ? (entry[1] || entry[0]) : entry;
          this.province.add(new Option(label, value));
        });
        if (selected && provinces.length) this.province.value = selected;
        if (this.provinceWrap) this.provinceWrap.hidden = provinces.length === 0;
        this.province.disabled = provinces.length === 0;
      }
    });
  })();

  (() => {
    if (customElements.get('confirm-delete')) return;
    customElements.define('confirm-delete', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form || form.dataset.bound) return;
        form.dataset.bound = 'true';
        form.addEventListener('submit', (e) => {
          if (!window.confirm(this.dataset.confirm || 'Are you sure?')) e.preventDefault();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ember-copy-code')) return;
    customElements.define('ember-copy-code', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('[data-copy]');
        const code = this.querySelector('[data-code]');
        const label = this.querySelector('[data-copy-label]');
        if (!btn || !code) return;
        btn.addEventListener('click', async () => {
          const text = code.textContent.trim();
          try {
            await navigator.clipboard.writeText(text);
          } catch (e) {
            const range = document.createRange();
            range.selectNodeContents(code);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            try { document.execCommand('copy'); } catch (err) { /* ignore */ }
          }
          if (label && this.dataset.copied) {
            const original = label.textContent;
            label.textContent = this.dataset.copied;
            setTimeout(() => { label.textContent = original; }, 2000);
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('ember-copy-code')) {
      customElements.define('ember-copy-code', class extends HTMLElement {
        connectedCallback() {
          const btn = this.querySelector('[data-copy]');
          const code = this.querySelector('[data-code]');
          const label = this.querySelector('[data-copy-label]');
          if (!btn || !code) return;
          btn.addEventListener('click', async () => {
            const text = code.textContent.trim();
            try {
              await navigator.clipboard.writeText(text);
            } catch (e) {
              const range = document.createRange();
              range.selectNodeContents(code);
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(range);
              try { document.execCommand('copy'); } catch (err) { /* ignore */ }
            }
            if (label && this.dataset.copied) {
              const original = label.textContent;
              label.textContent = this.dataset.copied;
              setTimeout(() => { label.textContent = original; }, 2000);
            }
          });
        }
      });
    }

    if (customElements.get('promo-popup')) return;

    const store = {
      get(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } },
      set(key, value) { try { window.localStorage.setItem(key, value); } catch (e) { /* storage blocked */ } },
      sget(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } },
      sset(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) { /* storage blocked */ } }
    };
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

    customElements.define('promo-popup', class extends HTMLElement {
      connectedCallback() {
        this.key = `ember-popup-${this.dataset.sectionId}`;
        this.onKey = (e) => {
          if (!this.classList.contains('is-open')) return;
          if (e.key === 'Escape') { this.close(); return; }
          if (e.key === 'Tab') this.trap(e);
        };
        document.addEventListener('keydown', this.onKey);
        this.addEventListener('click', (e) => { if (e.target.closest('[data-popup-close]')) { e.preventDefault(); this.close(); } });

        const designMode = this.dataset.designMode === 'true' || (window.Shopify && window.Shopify.designMode);
        if (designMode) {
          if (this.dataset.preview === 'true') this.open(false);
          this.onSelect = (e) => { if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open(false); };
          this.onDeselect = (e) => { if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close(false); };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          return;
        }
        if (this.dataset.enabled !== 'true') return;

        const success = this.querySelector('[data-popup-success]');
        const ownPost = window.location.hash === `#${this.dataset.formId}`;
        if (ownPost) {
          if (success) store.set(this.key, 'subscribed');
          this.open();
          return;
        }
        if (success) { store.set(this.key, 'subscribed'); return; }
        if (!this.shouldShow()) return;

        const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
        this.timer = setTimeout(() => this.open(), delay);

        if (this.dataset.exit === 'true' && window.matchMedia('(min-width: 990px) and (hover: hover)').matches) {
          this.onExit = (e) => { if (!e.relatedTarget && e.clientY <= 4) this.open(); };
          document.addEventListener('mouseout', this.onExit);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKey);
        if (this.onExit) document.removeEventListener('mouseout', this.onExit);
        if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
        if (this.classList.contains('is-open')) this.unlock();
      }
      shouldShow() {
        const saved = store.get(this.key);
        if (saved === 'subscribed') return false;
        const days = Number(this.dataset.days) || 0;
        if (days === 0) return store.sget(this.key) !== 'shown';
        const ts = Number(saved);
        return !ts || Date.now() - ts > days * 86400000;
      }
      open(remember = true) {
        if (this.classList.contains('is-open')) return;
        if (this.shown && remember) return;
        this.shown = true;
        clearTimeout(this.timer);
        if (this.onExit) document.removeEventListener('mouseout', this.onExit);
        if (document.body.classList.contains('is-locked') && remember) {
          // another drawer/modal is open – try again later
          this.shown = false;
          this.timer = setTimeout(() => this.open(), 4000);
          return;
        }
        this.opener = document.activeElement;
        this.classList.add('is-open');
        this.lock();
        if (remember) store.sset(this.key, 'shown');
        const target = this.querySelector('.promo__input') || this.querySelector('[data-popup-close].promo__close');
        if (target) setTimeout(() => target.focus({ preventScroll: true }), 60);
      }
      close(remember = true) {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.unlock();
        if (remember && store.get(this.key) !== 'subscribed') store.set(this.key, String(Date.now()));
        if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
      }
      lock() {
        if (window.Ember && window.Ember.lockScroll) window.Ember.lockScroll();
        else document.body.classList.add('is-locked');
      }
      unlock() {
        if (window.Ember && window.Ember.unlockScroll) window.Ember.unlockScroll();
        else document.body.classList.remove('is-locked');
      }
      trap(e) {
        const items = Array.from(this.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-recommendations')) return;
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.slider')) { this.wrapSlider(); return; }
        const load = () => {
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.querySelector('product-recommendations');
              if (fresh && fresh.innerHTML.trim().length) {
                this.innerHTML = fresh.innerHTML;
                this.wrapSlider();
                this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
              }
            })
            .catch(() => {});
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this);
        } else {
          load();
        }
      }
      wrapSlider() {
        const inner = this.querySelector('.page-width');
        if (!inner || inner.closest('slider-component') || inner.querySelector('slider-component')) return;
        const wrap = document.createElement('slider-component');
        while (inner.firstChild) wrap.appendChild(inner.firstChild);
        inner.appendChild(wrap);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('count-up')) return;

    const parse = (text) => {
      const m = String(text).trim().match(/^([^\d]*)(\d(?:[\d.,]*\d)?)(.*)$/);
      if (!m) return null;
      const raw = m[2];
      const seps = raw.replace(/\d/g, '');
      let dec = '';
      let thou = '';
      if (seps.length) {
        const lastIdx = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(','));
        const last = raw[lastIdx];
        const after = raw.length - lastIdx - 1;
        if (new Set(seps.split('')).size === 2) { dec = last; thou = seps[0]; }
        else if (seps.length > 1 || after === 3) { thou = last; }
        else { dec = last; }
      }
      let clean = raw;
      if (thou) clean = clean.split(thou).join('');
      if (dec) clean = clean.replace(dec, '.');
      const value = parseFloat(clean);
      if (Number.isNaN(value)) return null;
      const decimals = dec ? raw.length - raw.lastIndexOf(dec) - 1 : 0;
      return { prefix: m[1], suffix: m[3], value, decimals, dec, thou };
    };

    const format = (p, n) => {
      const parts = n.toFixed(p.decimals).split('.');
      let int = parts[0];
      if (p.thou) int = int.replace(/\B(?=(\d{3})+(?!\d))/g, p.thou);
      return p.prefix + int + (parts[1] ? p.dec + parts[1] : '') + p.suffix;
    };

    customElements.define('count-up', class extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.items = Array.from(this.querySelectorAll('[data-count]')).map((el) => {
          if (!el.dataset.final) el.dataset.final = el.textContent;
          return { el, p: parse(el.dataset.final) };
        });
        if (this.dataset.animate !== 'true' || reduce || !('IntersectionObserver' in window)) {
          this.finish();
          return;
        }
        this.items.forEach(({ el, p }) => { if (p) el.textContent = format(p, 0); });
        this.io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.io.disconnect();
          this.run();
        }, { threshold: 0.35 });
        this.io.observe(this);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        cancelAnimationFrame(this.frame);
      }
      finish() {
        this.classList.add('is-active');
        this.items.forEach(({ el }) => { el.textContent = el.dataset.final; });
      }
      run() {
        this.classList.add('is-active');
        const duration = 1600;
        const start = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        const tick = (now) => {
          const t = Math.min(1, (now - start) / duration);
          this.items.forEach(({ el, p }) => { if (p) el.textContent = format(p, p.value * ease(t)); });
          if (t < 1) this.frame = requestAnimationFrame(tick);
          else this.finish();
        };
        this.frame = requestAnimationFrame(tick);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-reels')) return;
    customElements.define('video-reels', class extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce;
        this.reels = Array.from(this.querySelectorAll('[data-reel]')).filter((r) => r.querySelector('video'));
        this.reels.forEach((reel) => this.setup(reel));
        if (this.autoplay && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) this.play(video);
              else if (!video.paused) video.pause();
            });
          }, { threshold: [0, 0.6, 1] });
          this.reels.forEach((reel) => this.io.observe(reel));
        }
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
      setup(reel) {
        const video = reel.querySelector('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        const tap = reel.querySelector('[data-reel-tap]');
        const sound = reel.querySelector('[data-reel-sound]');
        const bar = reel.querySelector('.reel__progress');
        if (tap) tap.addEventListener('click', () => this.onTap(reel, video));
        if (sound) sound.addEventListener('click', (e) => { e.stopPropagation(); this.setSound(reel, video, video.muted); if (video.paused) this.play(video); });
        video.addEventListener('play', () => reel.classList.add('is-playing'));
        video.addEventListener('pause', () => reel.classList.remove('is-playing'));
        if (bar) {
          video.addEventListener('timeupdate', () => {
            if (video.duration) bar.style.setProperty('--progress', (video.currentTime / video.duration).toFixed(3));
          });
        }
      }
      play(video) {
        if (video.preload === 'none') video.preload = 'auto';
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }
      onTap(reel, video) {
        if (video.paused) {
          if (!this.autoplay) this.setSound(reel, video, true);
          this.play(video);
        } else if (video.muted) {
          this.setSound(reel, video, true);
        } else {
          video.pause();
        }
      }
      setSound(reel, video, on) {
        if (on) {
          this.reels.forEach((other) => {
            if (other === reel) return;
            const v = other.querySelector('video');
            if (v && !v.muted) this.setSound(other, v, false);
            if (v && !this.autoplay && !v.paused) v.pause();
          });
        }
        video.muted = !on;
        const btn = reel.querySelector('[data-reel-sound]');
        if (btn) {
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? this.dataset.labelOff : this.dataset.labelOn);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('deferred-video')) return;
    customElements.define('deferred-video', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mode === 'ambient') {
          this.video = this.querySelector('video');
          this.toggle = this.querySelector('[data-toggle]');
          if (!this.video) return;
          this.video.muted = true;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
            this.setState(true);
          }
          if (this.toggle) {
            this.toggle.addEventListener('click', () => {
              if (this.video.paused) { this.video.play().catch(() => {}); this.setState(false); }
              else { this.video.pause(); this.setState(true); }
            });
          }
          return;
        }
        const btn = this.querySelector('[data-play]');
        if (btn) btn.addEventListener('click', () => this.load());
      }
      setState(paused) {
        if (!this.toggle) return;
        this.toggle.classList.toggle('is-paused', paused);
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }
      load() {
        if (this.loaded) return;
        const tpl = this.querySelector('template');
        if (!tpl) return;
        this.loaded = true;
        this.appendChild(tpl.content.cloneNode(true));
        this.classList.add('is-playing');
        const media = this.querySelector('video, iframe');
        if (media) {
          if (media.tagName === 'VIDEO') media.play().catch(() => {});
          media.focus({ preventScroll: true });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
